const data = {
    products: [
        {
            id: 1,
            imgUrl: 'img/hamberB.jpg',
            dishId: 0,
            UnitPrice: 100000,
            leftQuantity: 12,
            type: 'food',
            name: "Combo Hamburger B",
            display: true
        },
        {
            id: 2,
            imgUrl: 'img/hamberA.jpg',
            dishId: 1,
            UnitPrice: 120000,
            leftQuantity: 4,
            type: 'food',
            name: "Combo Hamburger A",
            display: true,
        },
        {
            id: 3,
            imgUrl: 'img/pepsi.jpg',
            dishId: 2,
            UnitPrice: 20000,
            leftQuantity: 5,
            type: 'drinks',
            name: "Pepsi Lon",
            display: true
        },
        {
            id: 4,
            imgUrl: 'img/ccdc.jpg',
            dishId: 3,
            UnitPrice: 50000,
            leftQuantity: 20,
            type: 'food',
            name: "Cơm Chiên Dương Châu",
            display: true
        },
        {
            id: 5,
            imgUrl: 'img/psc.jpg',
            dishId: 4,
            UnitPrice: 20000,
            leftQuantity: 20,
            type: 'drinks',
            name: "Pepsi Vị Chanh",
            display: true
        },
        {
            id: 6,
            imgUrl: 'img/aqua.jpg',
            dishId: 5,
            UnitPrice: 15000,
            leftQuantity: 20,
            type: 'drinks',
            name: "Aquafina",
            display: true
        },
        {
            id: 7,
            imgUrl: 'img/milo.jpg',
            dishId: 6,
            UnitPrice: 20000,
            leftQuantity: 100,
            type: 'drinks',
            name: "Sữa Milo",
            display: true
        },
        {
            id: 8,
            imgUrl: 'img/ccgpl.jpg',
            dishId: 7,
            UnitPrice: 80000,
            leftQuantity: 20,
            type: 'food',
            name: "Cơm Chiên Gà Phi Lê",
            display: true
        },
        {
            id: 9,
            imgUrl: 'img/pv.jpg',
            dishId: 7,
            UnitPrice: 22222,
            leftQuantity: 20,
            type: 'refreshments',
            name: "Popcorn (Vừa)",
            display: true
        },
        {
            id: 10,
            imgUrl: 'img/ktv.jpg',
            dishId: 7,
            UnitPrice: 34000,
            leftQuantity: 20,
            type: 'refreshments',
            name: "Khoai Tây Viên Nhân Rau",
            display: true
        },
        {
            id: 11,
            imgUrl: 'img/garan.jpg',
            dishId: 7,
            UnitPrice: 281000,
            leftQuantity: 20,
            type: 'chicken',
            name: "Gà Rán (9 miến)",
            display: true
        },
        {
            id: 12,
            imgUrl: 'img/garanvakhoaitay.jpg',
            dishId: 7,
            UnitPrice: 381000,
            leftQuantity: 20,
            type: 'chicken',
            name: "Gà Rán Khoai Tây",
            display: true
        },
],
}

export default data;